import type { Entity } from '@backstage/catalog-model';
import type { KeyRolesFields } from '@ipen-portal/plugin-key-roles-common';
import type { FC } from 'react';

import { tss } from 'tss-react/mui';

import { useKeyRoles } from '../hooks';
import { KeyRoleListItem } from './KeyRoleListItem';

const useStyles = tss.create(({ theme }) => ({
  divider: {
    backgroundColor: theme.palette.border,
    marginLeft: theme.spacing(7),
  },
  listItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
}));

type Props = {
  clickable?: boolean;
  entity: Entity;
  rolesToExclude?: KeyRolesFields[];
  rolesToInclude?: KeyRolesFields[];
};

export const KeyRoleListItems: FC<Props> = ({
  clickable = true,
  entity,
  rolesToExclude,
  rolesToInclude,
}) => {
  const { classes } = useStyles();

  const roles = useKeyRoles(entity, {
    exclude: rolesToExclude,
    include: rolesToInclude,
  });

  return roles.map(field => (
    <KeyRoleListItem
      key={field.roleOptions.label}
      {...field}
      classNames={{
        divider: classes.divider,
        item: classes.listItem,
      }}
      clickable={clickable}
    />
  ));
};
